import { useField } from "formik";

import { Container, Grid } from "@mui/material";

import RichTextEditor from "@components/Forms/FormInputs/RichTextEditor";
import FormLabel from "@components/Forms/FormLabel/Index";

import FormField from "@pages/CreateCampaign/components/FormField";

import { OrganizationStore } from "@store/organizationStore";

export default function EditUserDetails() {
  const [emailSignatureField] = useField("emailSignature");
  const organization = OrganizationStore.getState().organization;

  return (
    <Container
      maxWidth="md"
      sx={{
        height: "100%",
        overflow: "auto",
        py: { md: 0, xs: 4 },
        width: "100%",
      }}
    >
      <Grid container spacing={4}>
        <Grid item md={6} xs={12}>
          <FormField
            inputLabel={"Job Title"}
            name={"jobTitle"}
            stepLabel={"Add your job title:"}
            stepNumber={1}
            tooltip={
              "Your job title will be added to all Campaign emails and saved to your Account for future campaigns.."
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <FormField
            inputLabel={"Organization Name"}
            isDisabled={!!organization}
            name={"organizationName"}
            stepLabel={"Add your organization name:"}
            stepNumber={2}
            tooltip={
              organization
                ? "Your Organization name can be updated from your Organization's Dashboard."
                : "Your organization name will be added to all Campaign emails and saved to your Account for future campaigns."
            }
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <FormLabel
            hasValue={!!emailSignatureField.value}
            label={"Add your email signature."}
            name={emailSignatureField.name}
            stepNumber={3}
            tooltip={
              "Your email signature will be added to all Campaign emails and saved to your Account for future campaigns."
            }
          />
          <RichTextEditor isShort name={emailSignatureField.name} />
        </Grid>
      </Grid>
    </Container>
  );
}
